import React from 'react';


const LessonContext = React.createContext({title: "", slug: ""});

export default LessonContext;